import { render, staticRenderFns } from "./AxAppFailureFallback.vue?vue&type=template&id=a004f866&"
import script from "./AxAppFailureFallback.vue?vue&type=script&lang=ts&"
export * from "./AxAppFailureFallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports